<mat-dialog-content class="flex-col justify-start">
  <div class="text-sm pb-2 w-50">{{title}}: @if (errorCount>0) {
    <span><b>{{errorCount}} errors</b></span>
  }</div>
  <div [innerHtml]="message"></div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="mt-3 w-100 justify-start items-center">
    <div class="w-100 flex-row justify-end items-center">
      <a mat-button class="dialog-btn" color="primary" (click)="onOKClick()"><span class="text-bold">{{okButtonText}}</span></a>
    </div>
  </div>
</mat-dialog-actions>
